import { render, staticRenderFns } from "./manageFeeInputForm.vue?vue&type=template&id=35157344&scoped=true&"
import script from "./manageFeeInputForm.vue?vue&type=script&lang=js&"
export * from "./manageFeeInputForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35157344",
  null
  
)

export default component.exports